var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcErrorfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_7668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 20L12.5146 18.6125C13.2396 18.0771 14.0145 17.5083 14.9395 16.8292L12.3521 14.6188L13.825 13.3479C14.402 14.0438 15.0187 14.7896 15.7854 15.7104L17.8437 13.1479L19.1354 14.5125L16.9666 16.7854L19.1333 18.6438L18.125 20H17.9166C17.2361 19.3208 16.5534 18.6403 15.8687 17.9583L13.75 20H13.5416Z",
    fill: "#A1B1CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 20L15.8688 17.9583C16.5521 18.6417 17.2347 19.3222 17.9167 20H13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7896 11.0792L15.625 13.2063L16.0771 13.2271C16.1355 13.0603 16.206 12.8941 16.2766 12.7278C16.4326 12.3603 16.5888 11.9925 16.6146 11.6167C16.7125 10.2292 16.7208 8.83542 16.6833 7.45001C16.6628 7.01859 16.4985 6.60645 16.2167 6.27917C14.925 4.87917 13.5917 3.51042 12.2333 2.17084C11.9399 1.89922 11.5633 1.73476 11.1646 1.70418C9.21665 1.62918 7.27499 1.59792 5.33124 1.59792C4.10415 1.59167 3.4604 2.20834 3.4354 3.43751C3.35068 7.73473 3.28124 12.0361 3.22707 16.3417C3.21249 17.5729 3.80624 18.2083 5.05624 18.25C5.50403 18.2649 5.95424 18.2606 6.40426 18.2563C7.21045 18.2485 8.01607 18.2408 8.80624 18.3438C10.3146 18.5417 11.3104 17.9313 12.2521 16.5083L10.1229 14.7854C11.1484 13.7469 12.0627 12.8234 12.9918 11.885C13.2556 11.6186 13.5205 11.351 13.7896 11.0792ZM11.0173 3.4263L11.0187 3.33542L14.038 6.46542L15 7.43334H14.9716L15.05 7.51459L10.9542 7.45001L10.9544 7.43334H10.9125V3.32084L11.0173 3.4263Z",
    fill: "#A1B1CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_7668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorfile);
export default __webpack_public_path__ + "static/media/ic-errorfile.5a7318fb6ff7c5a2f3cd7606f1ca9fd9.svg";
export { ForwardRef as ReactComponent };